import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { fade, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContentText from '@material-ui/core/DialogContentText'
import { Button, CircularProgress } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import ChooseEntityComponent from '../Entities/ChooseEntityComponent'

const useStyles = makeStyles(theme => ({
  root: {
    width: '80%',
    margin: '20px'
  },
  gridItem: {
    padding: '5px'
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto'
    }
  },
  helperCard: {
    border: '1px solid #d7e2db',
    borderRadius: 14,
    padding: theme.spacing(2),
    background: '#f7fbf8',
    marginBottom: theme.spacing(2)
  }
}))

const buildDefaultState = (entity, defaultSubcontractorVendor) => ({
  firstname: '',
  lastname: '',
  displayName: '',
  companyname: '',
  address: '',
  address2: '',
  city: '',
  state: '',
  zipcode: '',
  telephone: '',
  email: '',
  autopayMTC: false,
  autopayAll: false,
  contractor: false,
  HOA: false,
  doNotEmail: false,
  paperInvoice: false,
  jobSiteAddress: '',
  jobSiteCity: '',
  jobSiteZip: '',
  jobSiteIsBilling: false,
  crewNumber: '',
  name: '',
  entity: entity?._id || entity || null,
  sprayContractor: Boolean(defaultSubcontractorVendor?._id),
  subContractedHerbicide: Boolean(defaultSubcontractorVendor?._id),
  subcontractorVendor: defaultSubcontractorVendor?._id || null
})

const NewCrewModal = (props) => {
  const classes = useStyles()
  const [loading, setLoading] = React.useState(false)
  const [activeEntity, setEntity] = React.useState({})
  const [state, setState] = React.useState(buildDefaultState(null, props.defaultSubcontractorVendor))

  React.useEffect(() => {
    let nextEntity = null

    if (props.user.defaultEntity && props.user.entities?.length) {
      if (props.user.entities.length > 1) {
        const index = props.user.entities.findIndex(item => (item._id === props.user.defaultEntity))
        if (index > -1) nextEntity = props.user.entities[index]
      } else {
        nextEntity = props.user.entities[0]
      }
    } else if (props.user.entities?.length) {
      nextEntity = props.user.entities[0]
    }

    if (nextEntity?._id) {
      setEntity(nextEntity)
      setState(buildDefaultState(nextEntity, props.defaultSubcontractorVendor))
    } else {
      setState(buildDefaultState(null, props.defaultSubcontractorVendor))
    }
  }, [props.defaultSubcontractorVendor, props.user])

  const handleClose = () => {
    props.closeModal()
  }

  const handleSave = () => {
    setLoading(true)
    const obj = {
      crew: state,
      user: props.user
    }
    axios({
      method: 'post',
      url: `${props.url}/api/crews/addNewCrew`,
      data: obj
    }).then(response => {
      setLoading(false)
      if (response && response.data && response.data._id) {
        props.notification({
          type: 'success',
          title: 'Crew Created!',
          message: 'Crew Was Created Successfully'
        })
        setState(buildDefaultState(activeEntity, props.defaultSubcontractorVendor))
        props.updateParent({ crew: response.data })
      } else {
        props.notification({
          type: 'warning',
          title: 'Unknown Error',
          message: 'We Do Not Know Why This Shows Up...'
        })
      }
    })
  }

  const handleUpdateVisibleEntity = (entity) => {
    setEntity(entity)
    setState((current) => ({
      ...current,
      entity: entity?._id || null
    }))
  }

  return (
    <div className={classes.root}>
      <Dialog open={props.open} fullWidth={false} onClose={handleClose} maxWidth='sm' aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {props.defaultSubcontractorVendor?._id ? `Add Crew For ${props.defaultSubcontractorVendor.name}` : 'Add New Crew'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please Provide Crew Information Below
          </DialogContentText>

          {props.defaultSubcontractorVendor?._id ? (
            <div className={classes.helperCard}>
              <strong>Subcontractor Alignment</strong>
              <div style={{ marginTop: 6 }}>
                This crew will be linked to {props.defaultSubcontractorVendor.name} and saved with the subcontracted herbicide mobile configuration.
              </div>
            </div>
          ) : null}

          <Grid container>
            <Grid item lg={12}>
              <h3>Crew Information</h3>
            </Grid>
            {(props.user && props.user.entities && props.user.entities.length > 1) ? (
              <React.Fragment>
                <DialogContentText>
                  Please Choose The Crew&apos;s Entity
                </DialogContentText>
                <Grid item xs={12} lg={12} style={{ padding: 10 }}>
                  <ChooseEntityComponent allowAll={false} defaultEntity={activeEntity} title={'Assigned Entity'} user={props.user} updateParent={handleUpdateVisibleEntity} />
                  {(activeEntity && activeEntity._id) ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <img alt="Logo" src={`${process.env.PUBLIC_URL}/${activeEntity._id}_Logo.png`} style={{ margin: '5px', padding: '5px', maxWidth: 220, maxHeight: 100 }} />
                    </div>
                  ) : ''}
                </Grid>
              </React.Fragment>
            ) : (
              (activeEntity && activeEntity._id) ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <img alt="Logo" src={`${process.env.PUBLIC_URL}/${activeEntity._id}_Logo.png`} style={{ margin: '5px', padding: '5px', maxWidth: 220, maxHeight: 100 }} />
                </div>
              ) : ''
            )}

            <Grid item lg={12} xs={12} className={classes.gridItem}>
              <TextField
                autoFocus
                label="Crew Name"
                onChange={e => setState({ ...state, name: e.target.value })}
                name="crewname"
                value={state.name}
                margin="normal"
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" disabled={loading || !state.name || !activeEntity || !activeEntity._id} onClick={handleSave}>
            {loading ? <CircularProgress /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    url: state.url,
    user: state.user,
    notification: state.notification
  }
}

export default connect(mapStateToProps)(NewCrewModal)
